import { KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Typography, Theme } from '@material-ui/core';
import React, { FC, useContext, useEffect, useState} from 'react';

import { DateTimeControlDefinition } from '../services/layout';

import { useDataValue, useDataFieldValidity, useEditability, FormControlProps, useExpressionValue } from '../utils';
import { FormContext } from '../FormContext';
import { FormControl } from './FormControl';
// import { registry } from '../registry';
import { Moment, MomentInput } from 'moment';
import moment from 'moment';

export interface DatePickerProps extends FormControlProps<DateTimeControlDefinition> {
}

const useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    input: {
      maxWidth: '250px',
      background: 'white'
    },
    error: {
      color: theme.palette.error.main
    }
  });
})

export const DatePicker: FC<DatePickerProps> = function (e) {
  const definition = e.definition;
  const classes = useStyles({});
  const { onSetData, scope } = useContext(FormContext);
  const date = useDataValue(definition.dataPath);
  const error = useDataFieldValidity(definition.dataPath);
  const editable = useEditability(definition.editable);
  const defaultValue = useExpressionValue(definition.default);
  const [initialRender, setInitialRender] = useState(true);

  function handleDateChange(newDate: Moment | undefined | null) {
    if (typeof newDate === 'undefined' || newDate === null) {
      return;
    }
    if (newDate.isValid()) {
      let newValue;
      switch (definition.variant) {
        case 'date':
          newValue = newDate.format('YYYY-MM-DD');
          break;
        case 'time':
          newValue = newDate.format('hh:mm:ssZ');
        default:
          newValue = newDate.toISOString();
      }
      onSetData(definition.dataPath, scope, newValue);
    }
  }
  useEffect(() => {
      if (initialRender) {
        setInitialRender(false);
        return;
      }
    if (!date && defaultValue) {
      handleDateChange(moment(defaultValue as MomentInput));
    }
  }, [defaultValue , date, definition, initialRender]);
  let child;
  switch (definition.variant) {
    case 'date':
      child = (
        // any typings
        <KeyboardDatePicker
          placeholder = { 'MM/dd/yyyy' }
          value = { date as any ?? null }
          onChange = { (e) => handleDateChange(e?.startOf('day')) }
          mask = { '__/__/____' }
          autoOk = { true }
          format = { 'MM/DD/YYYY' }
          disabled = { !editable }
          className = { classes.input }>
        </KeyboardDatePicker>
      )
      break;
    case 'date-time':
      child = (
        // any typings
        <KeyboardDateTimePicker
          value = { date as any ?? null }
          placeholder = { 'MM/dd/yyyy hh:mm PM' }
          onChange = { (e) => handleDateChange(e) }
          mask = { '__/__/____ __:__ _M' }
          autoOk = { true }
          format = { 'MM/DD/YYYY hh:mm A' }
          disabled = { !editable }
          className = { classes.input }>
        </KeyboardDateTimePicker>
      )
      break;
    default:
      child = (
        <Typography variant = { 'body1' } className = { classes.error }>
          { "Unsupported mode '" + definition.variant + "' supplied to DateTimePicker for '" + definition.dataPath + "'" }
        </Typography>
      )
  }
  return <FormControl label = { definition.label } helpText = { definition.helpText } footnote = { definition.footnote } style = { definition.style } tableCell = { definition.tableCell } error = { error }>
          { child }
        </FormControl>
};

// registry.registerComponent('DateTimePicker', DatePicker);
